import { gql } from '@apollo/client'

const QUERY_STREAM_SSO_REDIRECT = gql`
  query generateStreamSso {
    generateStreamSso {
      redirect_url
    }
  }
`

export { QUERY_STREAM_SSO_REDIRECT }
